const sanitizeLocale = (locale?: string) => {
  const trimmed = locale?.trim()
  // Return 'en' as default if locale is empty or undefined
  return trimmed && trimmed.length > 0 ? trimmed : 'en'
}

export const formatDateSimple = (dateString?: string, locale?: string) => {
  const formatter = new Intl.DateTimeFormat(sanitizeLocale(locale), {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  })
  return dateString?.length ? formatter.format(new Date(dateString)) : ''
}

export const formatDateComplex = (dateString: string, format?: string) => {
  const defaultFormat = 'dd-mm-yyyy'
  const date = new Date(dateString)
  const lowerCaseFormat = format?.toLocaleLowerCase()

  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = String(date.getFullYear())

  const validatedFormat =
    lowerCaseFormat?.includes('dd') &&
    lowerCaseFormat?.includes('mm') &&
    lowerCaseFormat?.includes('yyyy')
      ? lowerCaseFormat
      : defaultFormat

  return validatedFormat
    .replace('dd', day)
    .replace('mm', month)
    .replace('yyyy', year)
}
